import script from "./questions.vue?vue&type=script&setup=true&lang=js"
export * from "./questions.vue?vue&type=script&setup=true&lang=js"

import "./questions.vue?vue&type=style&index=0&id=66b8c6bf&lang=less"

const __exports__ = script;

export default __exports__